var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModelAutoComplete',{attrs:{"label":_vm.label,"placeholder":_vm.label,"value":_vm.value,"vizKeyPath":[['value']],"items":_vm.regions,"item-selected":_vm.value,"required":true},on:{"debounce-end":_vm.getAutocompleteAddress,"selected":_vm.getFullAddress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }